export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 1_03.c64cb1e7.jpg";